import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const EditLoanImage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [position, setPosition] = useState("");
  const [oldImage, setOldImage] = useState("");
  const [newImage, setNewImage] = useState(null);

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const fetchImageDetails = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getSingleLoanImages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data.image;
      setSelectedLoanId(data.loan_id);
      setPosition(data.position);
      setOldImage(data.image);
    } catch (error) {
      console.error("Error fetching image details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedLoanId || !position) {
      alert("Loan and position are required");
      return;
    }

    const formData = new FormData();
    formData.append("loan_id", selectedLoanId);
    formData.append("position", position);
    if (newImage) {
      formData.append("image", newImage);
    }

    try {
      await axios.put(`${COMMON_API}/loan/editLoanImages/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });
      navigate(-1);
    } catch (error) {
      console.error("Error updating loan image:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
    fetchImageDetails();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Edit Loan Image</h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Loan select */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
            <select
              value={selectedLoanId}
              onChange={(e) => setSelectedLoanId(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">-- Select Loan --</option>
              {loans.map((loan) => (
                <option key={loan.id} value={loan.id}>
                  {loan.name}
                </option>
              ))}
            </select>
          </div>

          {/* Position */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Position</label>
            <input
              type="text"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              placeholder="Edit position..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Old image */}
          {oldImage && (
            <div>
              <p className="text-gray-600 mb-1">Current Image:</p>
              <img
                src={`${COMMON_API.replace("/api", "")}/ImgUploads/${oldImage}`}
                alt="Loan"
                className="w-full h-40 object-cover rounded-lg mb-3"
              />
            </div>
          )}

          {/* New Image */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Upload New Image (optional)</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setNewImage(e.target.files[0])}
              className="w-full"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
          >
            Update Image
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditLoanImage;
